module.exports = __webpack_public_path__ + "static/img/icon.1d16cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/timelog/icon.png
// module id = cMXz
// module chunks = 0